import { render, staticRenderFns } from "./ediofour.vue?vue&type=template&id=3ab84074"
import script from "./ediofour.vue?vue&type=script&lang=js"
export * from "./ediofour.vue?vue&type=script&lang=js"
import style0 from "./ediofour.vue?vue&type=style&index=0&id=3ab84074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports